import { Action, createReducer, on } from '@ngrx/store';
import { IAssetManagers } from '../models/asset-managers.model';
import * as productSolution from '../actions';

export const getAssetManagersFeatureKey = 'getAssetManagers';

export interface State {
  loaded: boolean;
  error?: Error | any;
  assetManagers: IAssetManagers[];
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  assetManagers: undefined
};

export const reducer = createReducer(
  initialState,
  on(
    productSolution.loadGetAssetManagerss,

    state => state
  ),
  on(productSolution.loadGetAssetManagerssSuccess, (state, action) => ({
    ...state,
    assetManagers: action.response,
    loaded: true
  })),

  on(productSolution.loadGetAssetManagerssFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export const selectAssetManagers = (state: State) => state.assetManagers;
export const selectAssetManagersLoaded = (state: State) => state.loaded;
export const selectAssetManagersError = (state: State) => state.error;
